/* import __COLOCATED_TEMPLATE__ from './user-search-row.hbs'; */
/* RESPONSIBLE TEAM: team-help-desk-experience */
import templateOnlyComponent from '@ember/component/template-only';
import type UserSummary from 'embercom/objects/inbox/user-summary';
import { type WithBoundArgs } from '@glint/template';
import type SearchResultRow from '../common/quick-search/search-result-row';

interface Signature {
  Element: HTMLElement;
  Args: {
    workspaceId: string;
    row: WithBoundArgs<typeof SearchResultRow, 'data' | 'selection' | 'rowIndex' | 'hidePopover'>;
    openUserProfile: (workspaceId: string, userId: string, event: MouseEvent) => void;
    copyUserId: (userId: string, event: MouseEvent) => void;
    user?: UserSummary;
  };
}

const UserSearchRow = templateOnlyComponent<Signature>();
export default UserSearchRow;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Inbox2::Search::UserSearchRow': typeof UserSearchRow;
  }
}
